import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

const useGetEmployees = (empId) => {
    const loginUserData = useSelector((state) => state.loginData.userData)
    const activeTabName = useSelector((state) => state.activeData?.activeNumberKey?.activeTab);

    // state for data
    const [employeeOptions, setEmployeeOptions] = useState([]);

    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const payload = {
                    empId: loginUserData?.empId,
                    departmentName: activeTabName === "Other Department Task" ? ["others"] : "",
                    subDepartment: "",
                };

                const res = await axios.post(
                    process.env.REACT_APP_BASE_URL + "/emp/getEmployeeByDepartment",
                    payload
                );

                if (res?.data?.data?.length) {
                    const options = res.data.data.map((item) => ({
                        value: item.empId,
                        label: `${item.firstName} ${item.lastName}`,
                    }));

                    setEmployeeOptions(options);
                } else {
                    setEmployeeOptions([]);
                }
            } catch (err) {
                console.log("Error fetching employees", err);
            }
        };

        fetchEmployees();
    }, [empId, activeTabName]);

    return { employeeOptions };
};

export default useGetEmployees;